module.exports = __webpack_public_path__ + "img/menu2.3769248f.png";